export function getPublicAlias(aliases = []) {
    return aliases.find(alias => !(alias.managed === true &&
        alias.host.toLowerCase().endsWith(".vitriumone.com")))
}

export function updatePublicAlias(aliases = [], host, managed) {
    const publicAlias = getPublicAlias(aliases)
    const updated = aliases.flatMap(alias => {
        if (alias !== publicAlias) return [alias]
        return host ? [{...alias, host, managed}] : []
    })

    if (!publicAlias && host) updated.push({host, managed})
    return updated
}
